module.exports = __webpack_public_path__ + "img/clas-ingl-thumb.23656730.jpg";